<template>
    <Portal>
        <div v-show="containerVisible" :ref="maskRef" @mousedown="onMaskClick" :class="cx('mask')" :style="sx('mask', true, { position })" v-bind="ptm('mask')">
            <transition name="p-sidebar" @enter="onEnter" @after-enter="onAfterEnter" @before-leave="onBeforeLeave" @leave="onLeave" @after-leave="onAfterLeave" appear v-bind="ptm('transition')">
                <div v-show="visible" :ref="containerRef" v-focustrap :class="cx('root')" role="complementary" :aria-modal="modal" v-bind="ptmi('root')">
                    <slot v-if="$slots.container" name="container" :onClose="hide" :closeCallback="hide"></slot>
                    <template v-else>
                        <div :ref="headerContainerRef" :class="cx('header')" v-bind="ptm('header')">
                            <slot name="header" :class="cx('title')">
                                <div v-if="header" :class="cx('title')" v-bind="ptm('title')">{{ header }}</div>
                            </slot>
                            <button v-if="showCloseIcon" :ref="closeButtonRef" v-ripple type="button" :class="cx('closeButton')" :aria-label="closeAriaLabel" @click="hide" v-bind="ptm('closeButton')" data-pc-group-section="iconcontainer">
                                <slot name="closeicon" :class="cx('closeIcon')">
                                    <component :is="closeIcon ? 'span' : 'TimesIcon'" :class="[cx('closeIcon'), closeIcon]" v-bind="ptm('closeIcon')"></component>
                                </slot>
                            </button>
                        </div>
                        <div :ref="contentRef" :class="cx('content')" v-bind="ptm('content')">
                            <slot></slot>
                        </div>
                    </template>
                </div>
            </transition>
        </div>
    </Portal>
</template>

<script>
/*
Вынужденная мера копипастить темплейт с пару изменениями в условиях с v-if, т.к. при открытии меню есть задержка
появления при перестроении DOM дерева. Теперь при обновлении компонента необходимо будет копипастить <template> из
оригинального компонента и менять. Возможно, в дальнейшем добавят какой-то параметр и можно будет убрать.
Измененные места:
v-if="containerVisible" -> v-show="containerVisible"
v-if="visible" -> v-show="visible"
 */
import Sidebar from "primevue/sidebar";

export default {
    extends: Sidebar,
}
</script>

<style>
.p-sidebar-visible {
    background-color: rgba(0, 0, 0, 0.4);
}
</style>
